'use strict';

let util = require('./util');

module.exports = function(param){
    // Adding support to use individual module standalone
    if(typeof param !== "object"){
        param = {};
    }
    return {
        util : util,
        init: util.buildInitParam(param)
    };
};


// WEBPACK FOOTER //
// ./src/core/index.js